import api from '../utils/api';

export const mailboxService = {
  // Status & feature gates
  getStatus: () => api.get('/crm/mailbox/status'),

  // Admin: OAuth application credentials
  getOAuthAppSettings: () => api.get('/crm/mailbox/oauth-app-settings'),
  updateOAuthAppSettings: (data) => api.put('/crm/mailbox/oauth-app-settings', data),

  // OAuth connect (returns { url } to open in a popup)
  getGoogleAuthorizeUrl: () => api.get('/crm/mailbox/oauth/google/authorize'),
  getMicrosoftAuthorizeUrl: () => api.get('/crm/mailbox/oauth/microsoft/authorize'),

  // Mailbox configs
  getConfigs: () => api.get('/crm/mailbox/configs'),
  createImapConfig: (data) => api.post('/crm/mailbox/configs', data),
  updateConfig: (id, data) => api.put(`/crm/mailbox/configs/${id}`, data),
  deleteConfig: (id) => api.delete(`/crm/mailbox/configs/${id}`),
  syncConfig: (id) => api.post(`/crm/mailbox/configs/${id}/sync`),

  // System sender (admin only — designates one IMAP/SMTP mailbox for automated system emails)
  setSystemSender: (mailboxId) => api.put(`/crm/mailbox/configs/${mailboxId}/set-system-sender`),
  clearSystemSender: () => api.delete('/crm/mailbox/system-sender'),
  testSystemEmail: (recipientEmail) => api.post('/settings/email/test', { recipient_email: recipientEmail }),

  // Threads & messages
  getThreads: (params) => api.get('/crm/mailbox/threads', { params }),
  getThread: (id) => api.get(`/crm/mailbox/threads/${id}`),
  getMessage: (id) => api.get(`/crm/mailbox/messages/${id}`),
  markMessageRead: (id) => api.put(`/crm/mailbox/messages/${id}/read`),
  replyToThread: (id, data) => api.post(`/crm/mailbox/threads/${id}/reply`, data),
  sendEmail: (data) => api.post('/crm/mailbox/send', data),
  deleteThread: (id) => api.delete(`/crm/mailbox/threads/${id}`),
  getUnreadCount: () => api.get('/crm/mailbox/unread-count'),
  attachmentDownloadUrl: (messageId, attachmentId) =>
    `${api.defaults.baseURL}/crm/mailbox/messages/${messageId}/attachments/${attachmentId}/download`,
  downloadAttachment: (messageId, attachmentId) =>
    api.get(`/crm/mailbox/messages/${messageId}/attachments/${attachmentId}/download`, { responseType: 'blob' }),
};

export default mailboxService;
